/**
 * Windows-95 3D bevel primitives, drawn into a Phaser `Graphics` object.
 *
 * Two edges of light + two edges of shadow give the classic chiselled look:
 * a *raised* bevel for the window/buttons (light top-left, dark bottom-right)
 * and a *sunken* bevel for inset fields like the list box and address bar
 * (dark top-left, light bottom-right). Coordinates are top-left origin.
 */

import Phaser from "phaser";

import { PALETTE } from "../config";

/** Raised panel/button face — pops *out* of the surface. */
export function drawRaisedBevel(
  g: Phaser.GameObjects.Graphics,
  x: number,
  y: number,
  w: number,
  h: number,
  face: number = PALETTE.win95Face,
): void {
  g.fillStyle(face, 1).fillRect(x, y, w, h);
  // Top + left: outer white, inner light gray.
  g.fillStyle(PALETTE.win95HiLite, 1);
  g.fillRect(x, y, w, 1);
  g.fillRect(x, y, 1, h);
  g.fillStyle(PALETTE.win95LightGray, 1);
  g.fillRect(x + 1, y + 1, w - 2, 1);
  g.fillRect(x + 1, y + 1, 1, h - 2);
  // Bottom + right: outer black, inner dark gray.
  g.fillStyle(PALETTE.win95DarkShadow, 1);
  g.fillRect(x, y + h - 1, w, 1);
  g.fillRect(x + w - 1, y, 1, h);
  g.fillStyle(PALETTE.win95Shadow, 1);
  g.fillRect(x + 1, y + h - 2, w - 2, 1);
  g.fillRect(x + w - 2, y + 1, 1, h - 2);
}

/** Sunken inset field — recedes *into* the surface (list boxes, text fields). */
export function drawSunkenBevel(
  g: Phaser.GameObjects.Graphics,
  x: number,
  y: number,
  w: number,
  h: number,
  face: number = PALETTE.win95Field,
): void {
  g.fillStyle(face, 1).fillRect(x, y, w, h);
  // Top + left: outer dark gray, inner black.
  g.fillStyle(PALETTE.win95Shadow, 1);
  g.fillRect(x, y, w, 1);
  g.fillRect(x, y, 1, h);
  g.fillStyle(PALETTE.win95DarkShadow, 1);
  g.fillRect(x + 1, y + 1, w - 2, 1);
  g.fillRect(x + 1, y + 1, 1, h - 2);
  // Bottom + right: outer white, inner light gray.
  g.fillStyle(PALETTE.win95HiLite, 1);
  g.fillRect(x, y + h - 1, w, 1);
  g.fillRect(x + w - 1, y, 1, h);
  g.fillStyle(PALETTE.win95LightGray, 1);
  g.fillRect(x + 1, y + h - 2, w - 2, 1);
  g.fillRect(x + w - 2, y + 1, 1, h - 2);
}
